import { watch, onUnmounted } from 'vue'

/**
 * Composable to lock/unlock body scrolling when a modal is open
 * @param {import('vue').Ref<boolean>} isOpen - Reactive reference to modal visibility
 */
export function useBodyScrollLock(isOpen) {
  let originalOverflow = null
  let originalPaddingRight = null

  const lockBodyScroll = () => {
    if (typeof document === 'undefined') return

    // Save original values
    originalOverflow = document.body.style.overflow
    originalPaddingRight = document.body.style.paddingRight

    // Calculate scrollbar width to prevent layout shift
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth

    // Lock scroll
    document.body.style.overflow = 'hidden'
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`
    }
  }

  const unlockBodyScroll = () => {
    if (typeof document === 'undefined') return

    // Restore original values
    document.body.style.overflow = originalOverflow || ''
    document.body.style.paddingRight = originalPaddingRight || ''
  }

  // Watch for changes in isOpen
  watch(
    isOpen,
    newValue => {
      if (newValue) {
        lockBodyScroll()
      } else {
        unlockBodyScroll()
      }
    },
    { immediate: true }
  )

  // Cleanup on unmount
  onUnmounted(() => {
    unlockBodyScroll()
  })
}
